import type { ReportSeverity } from '../report';

export type PathLookupGlobalEventName =
  // topic = GLOBAL
  | 'DEFAULT_GW_NOT_FOUND'
  | 'STARTING_INTERFACE_DOWN'
  | 'LOOP_DETECTED'
  | 'MCAST_RECEIVER_NOT_FOUND'
  | 'MCAST_SOURCE_NOT_FOUND'
  | 'SIMULATION_ERROR'
  | 'SIMULATION_LIMIT_REACHED'
  | 'CLOUD_LB_POOL_SAMPLED'
  | 'CLOUD_SOURCE_IP_NOT_ASSIGNED';

export type PathLookupTopicEventName =
  // topic = ACL
  | 'ACL_CONFIG_ERROR'
  | 'ACL_DENY'
  | 'ACL_PARSING_ERROR'
  | 'ACL_PERMIT'
  // topic = FORWARDING
  | 'FLOODING'
  | 'FORWARDING_ERROR'
  | 'LOOP_DETECTED'
  | 'MALFORMED_PACKET'
  | 'NEXTHOP_NOT_FOUND'
  | 'NEXTHOP_NULL0_IFACE'
  | 'NEXTHOP_SKIP_L3'
  // topic = NAT44
  | 'NAT44_PERMIT'
  | 'NAT44_CONFIG_ERROR'
  | 'NAT44_MISSING_EVALUATION_RULE'
  // topic = PBR
  | 'PBR_PERMIT'
  | 'PBR_CONFIG_ERROR'
  // topic = ZONEFW
  | 'ZONEFW_CONFIG_ERROR'
  | 'ZONEFW_DENY'
  | 'ZONEFW_PARSING_ERROR'
  | 'ZONEFW_PERMIT';

export const pathLookupEventTopics = [
  'ACL',
  'FORWARDING',
  'NAT44',
  'PBR',
  'ZONEFW',
] as const;
export type PathLookupEventTopic = (typeof pathLookupEventTopics)[number];

export type PathLookupResultFlag =
  | 'acl-deny'
  | 'cloud-source-ip-not-assigned'
  | 'flooding'
  | 'iteration-limit'
  | 'l2-part-skipped'
  | 'loop-detected'
  | 'no-dgw'
  | 'no-receiver'
  | 'no-source'
  | 'simulation-error'
  | 'zone-deny';

export type PathLookupGlobalEvent = {
  details?: string[];
  name: PathLookupGlobalEventName;
  severity: ReportSeverity;
};

export type PathLookupEventsSummary = {
  flags: PathLookupResultFlag[];
  global: PathLookupGlobalEvent[];
  topics: Record<PathLookupEventTopic, Record<ReportSeverity, number>>;
};
